export const roles = {
  admin: "admin",
  auditors: "auditors",
  channel: "channel",
  accountant: "accountant",
  metering: "metering",
  customerCare: "customercare",
  customerService: "customer service",
  vendor: "vendor",
  haudit: "haudit",
  billing: "billing",
  feeder: "feeder",
  headbilling: "headbilling",
  officer: "officer",
  operations: "operations",
  supervisor: "supervisor",
  headacct: "headacct",
  accounts: "ACCOUNTS".toLowerCase(),
  billingManager: "BILLING MANAGERS".toLowerCase(),
  headprepaid: "HEAD PREPAID".toLowerCase(),
  prepaidOfficer: "PREPAID OFFICERS".toLowerCase(),
  ICT: "ICT".toLowerCase(),
  test: "test",
  guest: "guest",
  common: "Prepaid Common User",
  commonuser: "prepaid common user",
};

